import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react"
import API from "../../service/api";
import { CustomSelect } from "../CustomSelect";
import { MDBBtn, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import { CustomModal, modalZIndex } from "../CustomModal";
import { Alert } from "../Alert";
import { TextInput } from "../core/inputs/TextInput";

export interface UserInviteModalProps {
    open: boolean;
    subcompanyId?: number;
    onClose: () => void;
    onDone?: () => void;
}
export const UserInviteModal = ({subcompanyId, open, onClose, onDone}: UserInviteModalProps) => {
    const { t } = useTranslation();
    const [inviteEmail, setInviteEmail] = useState('');
    const [rights, setRights] = useState<any[]>([]);
    const [inviteError, setInviteError] = useState('');
    const [loading, setLoading] = useState(false);  
    const [invitationURL, setInvitationURL] = useState('');
    const [selectedRightsId, setSelectedRightsId] = useState<number|null>(null);

    useEffect(() => {
        if (!open) return;
        setInviteEmail('');
        setRights([]);
        setInviteError('');
        setInvitationURL('');
        setSelectedRightsId(null);

        API.GET('/api/rights')
            .then(res => {
                const rs = res.rights;
                setRights(rs.filter((r: any) => r.private));
                const idx = rs.findIndex((r: any) => r.Name == 'Admin');
                if (idx > 0) setSelectedRightsId(rs[idx].id);
                else if (rs.length > 0) setSelectedRightsId(rs[0].id);
                if (onDone) onDone();
            })
            .catch(err => setInviteError(err.message));
    }, [open]);

    const invite = useCallback(async () => {
        setLoading(true);
        setInviteError('');
        setInvitationURL('');
        try {
            const { invitationId } = await API.POST(`/api/companies`+(subcompanyId !== undefined ? `/subcompanies/${subcompanyId}` : '')+'/invite', {
                email: inviteEmail,
                rightsId: selectedRightsId
            });
            setInviteEmail('');
            setInvitationURL(`${window.location.origin}/join?invitationId=${encodeURIComponent(invitationId)}`);
            if (onDone) onDone();
        }catch(err: any){
            setInviteError(err.message);
        }
    }, [inviteEmail, subcompanyId, selectedRightsId]);


    return (
        <CustomModal
            open={open}
            onClose={() => onClose()}
            title={t('invite_user')}
            footer={<>
                <MDBBtn color="secondary" onClick={onClose}>{t('cancel')}</MDBBtn>
                { !invitationURL && <MDBBtn color="primary" disabled={!inviteEmail} onClick={invite}>{t('invite')}</MDBBtn> }
            </>}
        >
            {!invitationURL && <>
                <TextInput label={t('email')} icon="envelope" value={inviteEmail} onValueChange={setInviteEmail}/>
                <div className="d-flex mb-2 flex-row align-items-center">
                    <MDBIcon icon="briefcase" fixed/>
                    <div className="col ms-2">
                        <CustomSelect title={t('permissions')}
                            items={rights.map(r => ({val: r.id, title: r.Name, icon: 'fas fa-lock'}))}
                            selected={selectedRightsId}
                            onSelect={id => setSelectedRightsId(id as number)}
                            zIndex={modalZIndex}
                            w100
                        />
                    </div>
                </div>
                
            </>}

            <Alert type="danger" message={inviteError}/>
            { invitationURL && <Alert type="success" message={<>{t('invite_success_link')} <a href={invitationURL} className="text-primary">{invitationURL}</a></>}/>}
        </CustomModal>
    )
}